var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-dialog",
    {
      attrs: {
        title: "库存调整",
        visible: _vm.dialogVisible,
        width: "600px",
        "close-on-click-modal": false,
      },
      on: {
        "update:visible": function ($event) {
          _vm.dialogVisible = $event
        },
        close: _vm.handleClose,
      },
    },
    [
      _vm.dialogVisible
        ? _c(
            "div",
            [
              _c(
                "el-form",
                {
                  ref: "stockForm",
                  attrs: {
                    model: _vm.stockForm,
                    rules: _vm.stockRules,
                    "label-width": "150px",
                  },
                },
                [
                  _c(
                    "el-form-item",
                    { attrs: { label: "调整方式：", prop: "adjustType" } },
                    [
                      _c(
                        "el-radio-group",
                        {
                          model: {
                            value: _vm.stockForm.adjustType,
                            callback: function ($$v) {
                              _vm.$set(_vm.stockForm, "adjustType", $$v)
                            },
                            expression: "stockForm.adjustType",
                          },
                        },
                        [
                          _c("el-radio", { attrs: { label: 1 } }, [
                            _vm._v("补充"),
                          ]),
                          _vm._v(" "),
                          _c("el-radio", { attrs: { label: 2 } }, [
                            _vm._v("减少"),
                          ]),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "el-form-item",
                    { attrs: { label: "库存调整数量：", prop: "adjustQty" } },
                    [
                      _c("el-input", {
                        attrs: { placeholder: "请输入" },
                        model: {
                          value: _vm.stockForm.adjustQty,
                          callback: function ($$v) {
                            _vm.$set(_vm.stockForm, "adjustQty", _vm._n($$v))
                          },
                          expression: "stockForm.adjustQty",
                        },
                      }),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c("el-form-item", { attrs: { label: "商品标题：" } }, [
                    _vm._v(
                      "\n        " + _vm._s(_vm.stockForm.title) + "\n      "
                    ),
                  ]),
                  _vm._v(" "),
                  _c("el-form-item", { attrs: { label: "累计投放：" } }, [
                    _vm._v(
                      "\n        " +
                        _vm._s(_vm.stockForm.stockTotal) +
                        "\n      "
                    ),
                  ]),
                  _vm._v(" "),
                  _c("el-form-item", { attrs: { label: "剩余库存：" } }, [
                    _vm._v(
                      "\n        " +
                        _vm._s(_vm.stockForm.stockRemain) +
                        "\n      "
                    ),
                  ]),
                  _vm._v(" "),
                  _c(
                    "el-form-item",
                    [
                      _c(
                        "el-button",
                        {
                          attrs: { type: "primary", loading: _vm.stockLoading },
                          on: {
                            click: function ($event) {
                              return _vm.submitStock("stockForm")
                            },
                          },
                        },
                        [_vm._v("确认")]
                      ),
                      _vm._v(" "),
                      _c(
                        "el-button",
                        {
                          on: {
                            click: function ($event) {
                              return _vm.resetStock("stockForm")
                            },
                          },
                        },
                        [_vm._v("重置")]
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          )
        : _vm._e(),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }